export function getHeaderText(component: string) {
  switch (component) {
    case "Home":
      return "HOME";
    case "AdminHome":
      return "";
    case "Comments":
      return "COMMENTS";
    case "SignOffPage":
      return "TBR COMMENTS - SIGN OFF";
    default:
      return "SUBMIT";
  }
}
